<template>
	<div class="topic_sum">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">专家评审打分</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>
						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<el-table id="table" :header-cell-style="tableStyle" border :data="topicSumData" style="width: 100%;margin-bottom: 20px;">
											<el-table-column prop="projectName" label="评审名称" width="350">
												<template slot-scope="scope">
													<el-button type="text" @click="goRoute(scope.row)">{{ scope.row.projectName }}</el-button>
												</template>
											</el-table-column>
											<el-table-column prop="submittedNum4" label="待评数"></el-table-column>
											<el-table-column prop="rating" label="已评数量"></el-table-column>
											<el-table-column prop="submittedNum2" label="剩余数量">
												<template v-slot:default="scope">
													{{ scope.row.submittedNum4 - scope.row.rating }}
												</template>
											</el-table-column>
											<el-table-column prop="submittedNum" label="是否提交">
												<template v-slot:default="scope">
													{{ scope.row.state == 6 ? '已提交' : '未提交' }}
												</template>
											</el-table-column>
											<el-table-column prop="eduExpertsSubjectGroup.reviewEndTime" label="预计结束时间" width="120"></el-table-column>
											<el-table-column prop="projectUnitName" label="操作" width="200">
												<template slot-scope="scope">
													<el-button size="small" type="primary" @click="goRoute(scope.row)">进入评审</el-button>
													<el-button size="small" type="primary" v-if="scope.row.state !== 6" @click="goRoute2(scope.row)">提交评审</el-button>
												</template>
											</el-table-column>
										</el-table>
										<div class="pagination">
											<el-pagination
												@size-change="handleSizeChange"
												@current-change="handleCurrentChange"
												:current-page="pageNumber"
												:page-sizes="[50, 100, 200]"
												:page-size="pageSize"
												layout="total, sizes, prev, pager, next, jumper"
												:total="underStudyTopicTotal"
											></el-pagination>
										</div>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import { getProjectList, ExpertsScoreUp, saveOrUpdateExpertsScoreUp } from '@/api/after/newInterface';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			tableStyle: {
				backgroundColor: '#7e9be2',
				color: '#fff',
				textAlign: 'center'
			},
			topicSumData: [],
			underStudyTopicTotal: 10,
			pageNumber: 1,
			pageSize: 20,
			input: ''
		};
	},
	created() {
		this.getTable();
	},
	methods: {
		handleSizeChange(val) {
			this.pageSize = val;
			this.getTable();
		},
		handleCurrentChange(val) {
			this.pageNumber = val;
			this.getTable();
		},
		goRoute2(row) {
			ExpertsScoreUp(row.id).then(res => {
				if (res.code == 200) {
					if (res.data) {
						this.$confirm('提交我的评审后，不能再修改评分和评语，确定要提交吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							saveOrUpdateExpertsScoreUp(row.id).then(res => {
								if (res.code == 200) {
									this.$message.success(res.msg);
								} else {
									this.$message.error(res.data);
								}
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				} else {
					this.$message.error(res.data);
				}
			});
		},
		goRoute(row) {
			this.$router.push({ path: `/backstage/reviewWorksIndividual?id=${row.id}&state=${row.state}` });
		},
		getTable() {
			let params = {
				pageNumber: this.pageNumber,
				pageSize: this.pageSize,
				type: 3,
				isolation: 1
			};
			getProjectList(params).then(res => {
				this.topicSumData = res.data.records;
				this.underStudyTopicTotal = res.data.total;
			});
		}
	}
};
</script>

<style scoped lang="scss">
::v-deep .el-date-editor.el-input {
	width: 100%;
}
.btn_wrap {
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	// justify-content: space-between;
}
.pagination {
	display: flex;
	justify-content: center;
}
</style>
